import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, Loader } from 'lucide-react';
import { loginApi } from '../api';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError('');
    setLoading(true);
    try {
      const { user } = await loginApi({ email: email.trim().toLowerCase(), password });
      const destination = user.role === 'agent' ? '/agent' : '/';
      navigate(destination, { replace: true });
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Credenciales inválidas. Revisa tu correo y contraseña.');
      } else if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError('No se pudo iniciar sesión. Intenta de nuevo.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <form onSubmit={handleSubmit} style={card}>
        <div style={logo}>
          GP<span style={{ color: '#818cf8' }}>Voice</span>
        </div>
        <div style={subtitle}>Iniciar sesión</div>

        <label style={label}>Correo electrónico</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
          style={input}
          placeholder="correo@ejemplo.com"
          disabled={loading}
        />

        <label style={label}>Contraseña</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
          style={input}
          placeholder="••••••••"
          disabled={loading}
        />

        {error && <div style={errorBox}>{error}</div>}

        <button type="submit" disabled={loading || !email || !password} style={{
          ...submitBtn,
          opacity: loading || !email || !password ? 0.5 : 1,
          cursor: loading || !email || !password ? 'not-allowed' : 'pointer',
        }}>
          {loading ? (
            <>
              <Loader size={15} style={{ animation: 'spin 1s linear infinite' }} />
              Verificando...
            </>
          ) : (
            <>
              <LogIn size={15} />
              Entrar
            </>
          )}
        </button>

        <div style={footerHint}>
          Analítica de call center — Grupo Presidente / IHG
        </div>
      </form>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

const page = {
  minHeight: '100vh',
  background: '#0f0f13',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
  color: '#e0e0e6',
  fontFamily: 'inherit',
};

const card = {
  width: '100%',
  maxWidth: 380,
  background: '#1a1a24',
  border: '1px solid #2d2d44',
  borderRadius: 12,
  padding: '28px 28px 24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 8px 30px rgba(0,0,0,0.45)',
};

const logo = {
  fontSize: 26,
  fontWeight: 800,
  letterSpacing: -0.5,
  marginBottom: 4,
};

const subtitle = {
  fontSize: 13,
  color: '#9ca3af',
  marginBottom: 22,
};

const label = {
  fontSize: 12,
  color: '#9ca3af',
  marginBottom: 6,
  marginTop: 10,
  fontWeight: 600,
};

const input = {
  background: '#0f0f13',
  border: '1px solid #2d2d44',
  borderRadius: 8,
  padding: '10px 12px',
  color: '#e2e8f0',
  fontSize: 14,
  outline: 'none',
  fontFamily: 'inherit',
};

const errorBox = {
  marginTop: 14,
  background: 'rgba(248,113,113,0.10)',
  border: '1px solid rgba(248,113,113,0.3)',
  color: '#fca5a5',
  borderRadius: 8,
  padding: '8px 12px',
  fontSize: 12,
  lineHeight: 1.5,
};

const submitBtn = {
  marginTop: 18,
  background: '#818cf8',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  padding: '11px 14px',
  fontSize: 14,
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
};

const footerHint = {
  marginTop: 18,
  fontSize: 11,
  color: '#4b5563',
  textAlign: 'center',
};
